module.exports = __webpack_public_path__ + "img/6-1.ce7e18c5.jpg";